export const iconFontAwesomeCharityHandHoldingHand = (
	<i className="fa-solid fa-hand-holding-hand"></i>
);
